var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.233597,
    y: 0.233597,
    width: 86.7412,
    height: 86.7412
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.38px)",
      clipPath: "url(#bgblur_0_1661_1031_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1661_1031)",
    "data-figma-bg-blur-radius": 8.7664
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 69.2084,
    height: 69.2084,
    rx: 34.6042,
    fill: "#FF4F2D",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4637 49.0832C53.0116 47.4395 53.4665 45.1787 53.4665 43.6042C53.4665 38.1575 49.0511 33.742 43.6043 33.742C38.1575 33.742 33.7421 38.1575 33.7421 43.6042C33.7421 45.1787 34.197 47.4395 34.7449 49.0832",
    stroke: "#FF8972",
    strokeWidth: 1.6437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2911 51.937L38.3867 46.4672C38.1838 45.9565 37.5354 45.7006 37.002 45.8284C35.3467 46.3802 34.4501 48.1757 34.9994 49.8388L35.4793 51.2921C36.0286 52.9551 37.8156 53.856 39.4709 53.3041C39.976 53.089 40.4313 52.4689 40.2911 51.937Z",
    stroke: "#FF8972",
    strokeWidth: 1.6437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9174 51.937L48.8218 46.4672C49.0247 45.9565 49.6731 45.7006 50.2066 45.8284C51.8618 46.3802 52.7584 48.1757 52.2091 49.8388L51.7292 51.2921C51.18 52.9551 49.3928 53.856 47.7376 53.3041C47.2325 53.089 46.7771 52.4689 46.9174 51.937Z",
    stroke: "#FF8972",
    strokeWidth: 1.6437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1661_1031",
    x: 0.233597,
    y: 0.233597,
    width: 86.7412,
    height: 86.7412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.26121,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1661_1031"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.453826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.309804 0 0 0 0 0.176471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1661_1031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1661_1031",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.907652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.71504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.309804 0 0 0 0 0.176471 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1661_1031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1661_1031_clip_path",
    transform: "translate(-0.233597 -0.233597)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 69.2084,
    height: 69.2084,
    rx: 34.6042
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame31);
export default __webpack_public_path__ + "static/media/Frame 31.ebe83e5392cd709e39b41878ffda5ddd.svg";
export { ForwardRef as ReactComponent };